// @ts-nocheck
import React from "react";
import { PresenceUser } from "./useLiveSheet";
import { initials } from "@/lib/liveSheets";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export default function PresenceBar({ users }: { users: PresenceUser[] }) {
  if (!users?.length) return null;
  return (
    <TooltipProvider>
      <div className="flex items-center -space-x-2">
        {users.slice(0, 6).map((u, i) => (
          <Tooltip key={u.email + i}>
            <TooltipTrigger asChild>
              <div
                className="h-7 w-7 rounded-full flex items-center justify-center text-[10px] font-semibold text-white ring-2 ring-white"
                style={{ backgroundColor: u.color }}
              >
                {initials(u.name, u.email)}
              </div>
            </TooltipTrigger>
            <TooltipContent>{u.name || u.email}</TooltipContent>
          </Tooltip>
        ))}
        {users.length > 6 && (
          <div className="h-7 w-7 rounded-full bg-slate-500 flex items-center justify-center text-[10px] font-semibold text-white ring-2 ring-white">
            +{users.length - 6}
          </div>
        )}
      </div>
    </TooltipProvider>
  );
}
